import Vue from 'vue';
import axios from 'axios';
import NavDesk from './desk/NavDesk.vue';
import NavMobile from './mobile/NavMobile.vue';

axios.get(`/marketing-api/main-navigation.json`).then((response) => {
    const navDesk = document.querySelector('#vue-nav-desk');
    if (navDesk) {
        new Vue({
            el: document.querySelector('#vue-nav-desk'),
            render: (h) =>
                h(NavDesk, {
                    props: {
                        navData: response.data,
                        ctaText: navDesk.getAttribute('data-cta-text'),
                        ctaUrl: navDesk.getAttribute('data-cta-url')
                    }
                })
        });
    }

    const navMobile = document.querySelector('#vue-nav-mobile');
    if (navMobile) {
        new Vue({
            el: document.querySelector('#vue-nav-mobile'),
            render: (h) =>
                h(NavMobile, {
                    props: {
                        node: {
                            children: response.data.nodes
                        }
                    }
                })
        });
    }
});
